import React from "react"

export default function Loader({ className = "" }) {
    return (
        <div className={`d-flex justify-content-center align-items-center py-5${className}`}>
            <div className="spinner-border" role="status" style={{width: 32, height: 32, color: '#D1D5DB'}}>
                <span className="visually-hidden">Loading...</span>
            </div>
        </div>
    )
}